import React, { useEffect, useState } from 'react'
import { aedLogoStyle, btnContainerAuction, btnContainerShow, getDirhamImage, iconContainer, pageTitleAuction, pageTitleShow, serviceRequestHeadContainer, showIconsContainer, whiteCard } from '../../common/cssclasses'
import PillBtn from '../../components/PillBtn'
import { useLocation } from 'react-router';
import { enrollBidder, getAuctionById } from './api/auctionApis';
import { useTranslate } from '../../components/TranslationText';
import { formatDateTimeInArabic } from '../../helper/formateDateTimeToArabic';
import { AuctionTimer } from '../../components/auctions/header';
import NetaqInput from '../../components/NetaqInput';
import CustomPopUp from '../../components/CustomPopUp';
import CustomSecondPopUp from '../../components/CustomSecondPopUp';
import ImagesSlider from '../../components/ImagesSlider';
import { Link } from 'react-router-dom';
import AuctionDates from '../../components/auctions/AuctionDates';
import HorseList from '../../components/auctions/HorseList';


const BaseURL = process.env.REACT_APP_BASE_URL;

export default function AuctionDetails({ toast }) {
    const { translate } = useTranslate();
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const auctionId = searchParams.has("id") ? searchParams.get("id") : "";
    // const auctionId = "2803ca14-a46f-4625-1b0c-08dd91e8e9a7";
    const [auctionDetails, setAuctionDetails] = useState({});
    const [loaded, setLoaded] = useState(false);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [isBidForOthers, setIsBidForOthers] = useState(false);

    const handleExternalLink = (url) => {
        const currentURL = window.location.href;
        window.location.href = url + `&returnUrl=${currentURL}`; // Opens the URL in a new tab
    };


    useEffect(() => {
        getAuctionById(auctionId).then((res) => {
            setAuctionDetails(res);
            setLoaded(true)
        })

    }, [])

    const showEnrollmentBtn = (auctionDetails?.isUserEnrolled == false) && auctionDetails?.isEnrollOpened

    function enrollNow() {
        enrollBidder(auctionId, userProfile?.id, isBidForOthers).then((res) => {
            if (!!res) {
                handleExternalLink(res);
            } else {
                toast.error(translate('web.errorInEnrollmentPleaseContantTheAdmin', 'Error In Enrollment Please Contant The Admin'))
            }

        })
    }

    return (
        loaded && <>
            <div className={serviceRequestHeadContainer}>
                <h2 className={pageTitleAuction}>
                    {auctionDetails?.name}
                </h2>

                <div className={btnContainerAuction + " row"} >
                    {!!showEnrollmentBtn && !!userProfile?.id &&
                        <div className='col-md-6 col-12 mb-from-group ms-auto'>
                            <CustomSecondPopUp
                                trigger={<PillBtn
                                    isNoMargin
                                    isNoAction={true}
                                    isWithClass
                                    isSubmitBtn
                                    classes='btn btn-outline-danger'
                                    text={auctionDetails?.paymentStatus == 'PendingPayment' ? translate('web.completePayment') : translate('web.enrollNow')}
                                />}
                                title={translate("web.enrollment", "Enrollment") + " - " + auctionDetails?.name}
                                btnText={translate(
                                    "web.confirmAndPayNow",
                                    "Confirm & Pay Now"
                                )}
                                onSave={() => enrollNow()}
                                isDisabled={!acceptTerms}

                            >
                                <div className="text-start mb-main">
                                    <h4 className="red fw-bold">
                                        {translate("web.auctionFees", "Auction Fees")}:{" "}
                                        {auctionDetails?.auctionFees} {translate("web.aed", "AED")}
                                    </h4>
                                </div>

                                <div className={showIconsContainer}>
                                    {!!userProfile?.fullName &&
                                        <div className={iconContainer}>
                                            <i className="fa fa-user red"></i>
                                            <span>{userProfile?.fullName}</span>
                                        </div>
                                    }
                                    <div className={iconContainer}>
                                        <img src={getDirhamImage(currentLanguage)} alt='AED' style={aedLogoStyle} />
                                        <span>{auctionDetails?.auctionFees} {translate("web.aed", "AED")}</span>
                                    </div>
                                    {!!userProfile?.nationalityName &&
                                        <div className={iconContainer}>
                                            <i className="fa fa-globe-americas red"></i>
                                            <span>{userProfile?.nationalityName}</span>
                                        </div>
                                    }
                                    {!!userProfile?.address &&
                                        <div className={iconContainer}>
                                            <i className="fa-solid fa-location-dot red"></i>
                                            <span>{userProfile?.address}</span>
                                        </div>
                                    }
                                    {!!userProfile?.phone &&
                                        <div className={iconContainer}>
                                            <i className="fa-solid fa-phone red"></i>
                                            <span>{userProfile?.phone}</span>
                                        </div>
                                    }
                                </div>


                                <NetaqInput
                                    key={'participateforOthers'}
                                    name='participateforOthers'
                                    type="checkbox"
                                    label={translate(
                                        "web.isBidForOthers",
                                        "Is Bid For Others"
                                    )}
                                    value="accepted"
                                    checked={isBidForOthers}
                                    onChange={(e) => setIsBidForOthers(e.target.checked)}
                                />
                                <CustomPopUp
                                    title={translate('web.termsAndConditions', 'TermsAndConditions')}
                                    trigger={
                                        <NetaqInput
                                            key={'participateforOthers'}
                                            name='participateforOthers'
                                            type="checkbox"
                                            label={translate(
                                                "web.iAgreeToTheTermsAndConditionsOfTheAuction",
                                                "I agree to the terms and conditions of the auction"
                                            )}
                                            value="accepted"
                                            checked={acceptTerms}
                                            onChange={(e) => setAcceptTerms(e.target.checked)}
                                            isLink
                                        />
                                    }
                                    content={<div
                                        className="text-start"
                                        dangerouslySetInnerHTML={{ __html: currentLanguage == 'en' ? auctionDetails?.termsAndConditionsTextEn : auctionDetails?.termsAndConditionsTextAr }}
                                    />}
                                />
                            </CustomSecondPopUp>
                        </div>
                    }
                    {!!showEnrollmentBtn && !userProfile?.id &&
                        <div className='col-md-6 col-12 mb-from-group'>
                            <PillBtn
                                isNoMargin
                                isWithClass
                                isOutLine={true}
                                classes='btn btn-outline-danger'
                                text={translate('web.enrollNow')}
                                routeName={`/login?redirectURL=/auction?id=${auctionId}`}
                            />
                        </div>
                    }
                    {auctionDetails?.eventId &&
                        <div className='col-md-6 col-12 mb-from-group'>
                            <PillBtn
                                isNoMargin
                                isWithClass
                                classes="btn-secondary mb-2"
                                routeName={`/book-table?eventid=${auctionDetails?.eventId}`}
                                isRed={true}
                                text={translate('web.bookTable', 'Book Table')}
                            />
                        </div>
                    }
                    {auctionDetails?.isAuctionedOneByOne &&
                        auctionDetails.isAuctionLive &&
                        <div className='col-md-6 col-12 mb-from-group ms-auto'>
                            <PillBtn
                                isNoMargin
                                text={translate("web.watchNow", "Watch Now")}
                                isRed={true}
                                routeName={`/hybridBidding?auctionID=${auctionId}`}
                            />
                        </div>
                    }
                </div>
                <div className={showIconsContainer}>
                    {!!auctionDetails?.startDate && (
                        <div className={iconContainer} >
                            <i
                                className="fa fa-calendar C89C66"
                            ></i>
                            <span>{formatDateTimeInArabic(auctionDetails?.startDate, currentLanguage)}</span>
                        </div>
                    )}
                    {!!auctionDetails?.endDate && (
                        <div className={iconContainer} >
                            <i
                                className="fa fa-calendar C89C66"
                            ></i>
                            <span>{formatDateTimeInArabic(auctionDetails?.endDate, currentLanguage)}</span>
                        </div>
                    )}

                    <div className={iconContainer} >
                        <i className=" fa fa-gavel C89C66"></i>
                        <span>
                            {auctionDetails?.typeText}
                        </span>
                    </div>
                    {!!auctionDetails?.auctionFees &&
                        <div className={iconContainer} >
                            <img src={getDirhamImage(currentLanguage)} alt='AED' style={aedLogoStyle} />
                            <span>
                                {auctionDetails?.auctionFees?.toLocaleString('en-US')} {translate("web.aed", "AED")}
                            </span>
                        </div>
                    }

                    {!!auctionDetails?.horseCount && (
                        <div className={iconContainer} >
                            <i
                                className="fa-solid fa-chess-knight C89C66"
                            ></i>
                            <span>{auctionDetails?.horseCount} {auctionDetails?.horseCount > 1 ? <>{translate('web.horses', 'Horses')}</> : <>{translate('web.horse', 'Horse')}</>}</span>
                        </div>
                    )}
                    {!!auctionDetails?.endDate && new Date(auctionDetails?.endDate) > new Date() && (
                        <div className={iconContainer + " w-unset"}>
                            {new Date(auctionDetails?.endDate) > new Date() && (
                                <AuctionTimer auctionTimer={auctionDetails?.auctionTimer} startDate={auctionDetails?.startDate} endDate={auctionDetails?.endDate} />
                            )}
                        </div>
                    )}

                </div>
            </div>
            <div className="row">
                <div className="col-xl-8 col-lg-8 col-md-12 mb-main">
                    <div className={whiteCard}>
                        <ImagesSlider
                            data={auctionDetails?.auctionAttachment}
                            sliderName={"auctionSlider"}
                            type={"auctionSlider"}
                            VideoURL={[auctionDetails?.liveUrl, auctionDetails?.introVideoUrl]}
                        />
                    </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-12 mb-main">
                    <div className="bg-white p-main border-15 p-3 h-100 ">
                        {(!!auctionDetails?.inspectionStartDate || !!auctionDetails?.inspectionEndDate) &&
                            <>
                                <div className="mb-form-group">
                                    <label className="bold rtl capatalise">
                                        {translate("web.horsesViewDates", "Horses View Dates")}
                                    </label>
                                    <div className="col-12">
                                        <AuctionDates
                                            date={auctionDetails.inspectionStartDate}
                                            isWithLabel={false}
                                            currentLanguage={currentLanguage}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <AuctionDates
                                            date={auctionDetails.inspectionEndDate}
                                            isWithLabel={false}
                                            currentLanguage={currentLanguage}
                                        />
                                    </div>
                                </div>
                            </>
                        }
                        {(!!auctionDetails?.reservedBidNoStartDate || !!auctionDetails?.reservedBidNoEndDate) &&

                            <div className="mb-form-group">
                                <label className="bold rtl capatalise">
                                    {translate("web.reservedDates", "Reserved Dates")}
                                </label>
                                <div className="col-12" style={{ width: 'unset' }}>
                                    <AuctionDates
                                        date={auctionDetails.reservedBidNoStartDate}
                                        isWithLabel={false}
                                        currentLanguage={currentLanguage}
                                    />
                                </div>
                                <div className="col-12" style={{ width: 'unset' }}>
                                    <AuctionDates
                                        date={auctionDetails.reservedBidNoEndDate}
                                        isWithLabel={false}
                                        currentLanguage={currentLanguage}
                                    />
                                </div>
                            </div>
                        }

                        {auctionDetails?.paymentStatus !== "" && (
                            <div className="mb-form-group">
                                <label className="bold rtl capatalise">
                                    {translate("web.paymentStatus", "Payment Status")}:
                                </label>
                                <div className="col-12">
                                    {auctionDetails?.paymentStatus !== ""
                                        ? translate(
                                            `web.${auctionDetails?.paymentStatus?.toLowerCase()}`,
                                            auctionDetails?.paymentStatus
                                        )
                                        : ""}
                                </div>
                            </div>
                        )}
                        <div className="mb-form-group">
                            <label className="bold rtl capatalise">
                                {translate("web.auctionDetails", "Auction Details")}
                            </label>
                            {!!auctionDetails?.catalogUrl &&
                                <div className="col-12">
                                    <i className="fa-solid fa-file C89C66" ></i>
                                    <span>
                                        <Link
                                            target="_blank"
                                            to={auctionDetails?.catalogUrl}
                                            className="C89C66"
                                        >
                                            {translate(`web.auctionCatalog`, "Auction Catalog")}
                                        </Link>
                                    </span>
                                </div>
                            }
                            {!!auctionDetails?.location &&
                                <div className="col-12">
                                    <i className=" fa-solid fa-location-dot C89C66" ></i>
                                    <span>
                                        <Link
                                            target="_blank"
                                            to={auctionDetails?.location}
                                            className="C89C66"
                                        >
                                            {translate("web.showonGoogleMaps", "Show on Google Maps")}
                                        </Link>
                                    </span>
                                </div>
                            }
                            {(!!auctionDetails?.termsAndConditionsTextEn || !!auctionDetails?.termsAndConditionsTextAr) && (
                                <>
                                    <CustomPopUp
                                        trigger={
                                            <div key={'iFileItem'} className="col-12" style={{ cursor: 'pointer', }}>
                                                <i className=" fa-solid fa-file C89C66" ></i>
                                                <span className="C89C66">
                                                    {translate(
                                                        "web.showTermsandConditions",
                                                        "Show Terms and Conditions"
                                                    )}
                                                </span>
                                            </div>
                                        }
                                        title={translate('web.termsAndConditions', 'terms And Conditions')}
                                        content={
                                            <div
                                                className="text-start"
                                                dangerouslySetInnerHTML={{ __html: currentLanguage == 'en' ? auctionDetails?.termsAndConditionsTextEn : auctionDetails?.termsAndConditionsTextAr }}
                                            />
                                        }
                                    />
                                </>
                            )}
                        </div>
                    </div>

                </div>
            </div >

            <HorseList auctionId={auctionId} auction={auctionDetails} key={'Horse List'} />


        </>
    )
}
